
import Actions from './actions';
import Button from '../../../components/form/button.jsx';
import ControlGroup from '../../../components/form/control-group.jsx';
import React from 'react';
import Spinner from '../../../components/form/spinner.jsx';
import Store from './store';
import TextControl from '../../../components/form/text-control.jsx';
import TextareaControl from '../../../components/form/textarea-control.jsx';
import SelectControl from '../../../components/form/select-control.jsx';
import { Recaptcha } from '../../../components';
import { handleLocalStateChange } from '../../../utils/react';
const AUTHENTICATED_PAGE_PATH = process.env.CMC_PORTAL_AUTHENTICATED_PAGE_ABSOLUTE_PATH || '/';

class Form extends React.Component {
  constructor(props) {

    super(props);

    this.input = {};
    this.state = Store.getState();
    this.state.captcha = false;
  }

  componentDidMount() {

    this.unsubscribeStore = Store.subscribe(this.onStoreChange.bind(this));

    if (this.input.firstName) {
      this.input.firstName.focus();
    }

  }

  componentWillUnmount() {

    this.unsubscribeStore();

    Actions.resetStore();
  }

  onStoreChange() {
    this.setState(Store.getState());
  }

  handleSubmit(event) {

    event.preventDefault();
    event.stopPropagation();
    Actions.sendMessage({
      firstName: this.input.firstName.value(),
      lastName: this.input.lastName.value(),
      email: this.input.email.value(),
      jobTitle: this.input.jobTitle.value(),
      company: this.input.company.value(),
      companySize: this.input.companySize.value(),
      message: this.input.message.value(),
      captcha: this.state.captcha,
    });
  }

  render() {
    const alerts = [];

    if (this.state.success) {
      alerts.push(
        <div key="success" className="alert alert-success">
          Inquiry sent! We&#39;ll be getting back to you shortly.
        </div>
      );
    }

    if (this.state.validation.error) {
      //hack customized form error messages to be friendly
      const errorTarget = Object.keys(this.state.validation.hasError)[0];
      let errorMessage = this.state.validation.help[errorTarget];
      if (errorMessage){
        if (errorMessage.indexOf("not allowed to be empty")!==-1){
          errorMessage = "This field is required.";
        } else if (errorMessage.indexOf("must be a valid email")!==-1){
          errorMessage = "A valid email address is required.";
        } else if (errorMessage === '"captcha" must be a string'){
          errorMessage = "Please click the CAPTCHA box above to prove you are not a robot.";
        }
        this.state.validation.help[errorTarget] = errorMessage; // eslint-disable-line
      }
      alerts.push(
        <div key="danger" className="alert alert-danger">
          {this.state.validation.error}
        </div>
      );
    }

    let formElements;

    if (!this.state.success) {
      formElements = <fieldset>
        <div className="row">
          <div className="col-12">
            <h4>Our Enterprise Tier is reserved for plans that will exceed our premade options.</h4>

            <p>Please only contact us if at least one of the following is true:</p>
            <ul>
              <li>Your product/service is expected to exceed 100,000 users or any of the restrictions in our <a href="https://pro.coinmarketcap.com/user-agreement-commercial/" target="_blank">commercial terms</a>.</li>
              <li>You require more than 3,000,000 credits per-month</li>
              <li>You require more than 12 months of historical data</li>
              <li>Your per-minute call limit will exceed 80</li>
            </ul>

            <p><b>Note</b>: Credit usage can strongly depend on factors such as caching and how your product/service is engineered. Please consult your technical team for call estimates, prior to contact.</p>
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            <TextControl
              ref={(c) => (this.input.firstName = c)}
              name="firstName"
              label="First Name"
              autocomplete="given-name"
              autocapitalize="words"
              hasError={this.state.validation.hasError.firstName}
              help={this.state.validation.help.firstName}
              disabled={this.state.loading}
            />
          </div>
          <div className="col-6">
            <TextControl
              ref={(c) => (this.input.lastName = c)}
              name="lastName"
              label="Last Name"
              autocomplete="family-name"
              autocapitalize="words"
              hasError={this.state.validation.hasError.lastName}
              help={this.state.validation.help.lastName}
              disabled={this.state.loading}
            />
          </div>
        </div>
        <TextControl
          ref={(c) => (this.input.email = c)}
          name="email"
          type="email"
          label="Email Address"
          autocomplete="email"
          hasError={this.state.validation.hasError.email}
          help={this.state.validation.help.email}
          disabled={this.state.loading}
          maxlength="256"
        />
        <TextControl
          ref={(c) => (this.input.jobTitle = c)}
          name="jobTitle"
          label="Job Title"
          autocapitalize="words"
          autocomplete="organization-title"
          hasError={this.state.validation.hasError.jobTitle}
          help={this.state.validation.help.jobTitle}
          disabled={this.state.loading}
        />
        <div className="row">
          <div className="col-6">
            <TextControl
              ref={(c) => (this.input.company = c)}
              name="company"
              label="Company Name"
              autocomplete="organization"
              autocapitalize="words"
              hasError={this.state.validation.hasError.company}
              help={this.state.validation.help.company}
              disabled={this.state.loading}
            />
          </div>
          <div className="col-6">
            <SelectControl
              ref={(c) => (this.input.companySize = c)}
              name="companySize"
              label="Company Size"
              hasError={this.state.validation.hasError.companySize}
              help={this.state.validation.help.companySize}
              disabled={this.state.loading}
            >
              <option value="0-50">0-50</option>
              <option value="50-100">50-100</option>
              <option value="100-1,000">100-1,000</option>
              <option value="1,000 - 5,000">1,000 - 5,000</option>
              <option value="10,000 or more">10,000 or more</option>
            </SelectControl>
          </div>
        </div>
        <TextareaControl
          ref={(c) => (this.input.message = c)}
          name="message"
          label="Your Enterprise Needs and Budget"
          rows="5"
          hasError={this.state.validation.hasError.message}
          help={this.state.validation.help.message}
          disabled={this.state.loading}
        />

        <ControlGroup
          hasError={this.state.validation.hasError.captcha}
          help={this.state.validation.help.captcha}
        >
          <Recaptcha
            onChange={handleLocalStateChange.bind(this, 'captcha')}
          />
        </ControlGroup>

        <ControlGroup hideLabel={true} hideHelp={true}>
          <Button
            type="submit"
            inputClasses={{ 'btn-primary': true }}
            disabled={this.state.loading} >

            Send message
            <Spinner space="left" show={this.state.loading} />
          </Button>
        </ControlGroup>

      </fieldset>;
    }

    return (
      <section>
        <div className="contact-header px-3 py-3 pt-md-5 pb-md-4 mx-auto text-center">
          <h1 className="display-4">Let&#39;s customize an Enterprise Plan for you.</h1>
        </div>
        <form className="auth-form" onSubmit={this.handleSubmit.bind(this)} method="post">
          {alerts}
          {formElements}
        </form>
        <p className="text-center">Interested in a custom CSV data export instead? You can <a href={AUTHENTICATED_PAGE_PATH+'contact-data/'}>inquire here.</a></p>
      </section>
    );
  }
}


export default Form;



// WEBPACK FOOTER //
// ./client/pages/main/contact/form.jsx